import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

//Check accepted functions

export const checkAcceptedTerms = async (accessAuthToken: string): Promise<boolean> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/terms-and-conditions/accepted`;
    console.log("url: " + url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    // console.log("response", response);

    if (!response.ok) {
      // Preserve HTTP status so callers can detect deleted/invalid session (404/401)
      const err: Error & { status?: number } = new Error("Failed to check acceptance status");
      err.status = response.status;
      throw err;
    }

    const data = await response.json();
    // console.log("data", data);

    // console.log("checkAcceptedTerms", data);

    return data;
  } catch (error) {
    console.error("Error checking acceptance of terms and conditions:", error);
    showErrorToast("Failed to check acceptance status");
    throw error;
  }
};

//Get latest terms function

export const getLatestTerms = async (accessAuthToken?: string): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/terms-and-conditions/latest`;

    const headers: Record<string, string> = {};
    if (accessAuthToken) {
      headers.Authorization = `Bearer ${accessAuthToken}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to fetch terms and conditions");
    }

    const data = await response.json();
    // console.log("getLatestTerms", data);

    return data;
  } catch (error) {
    console.error("Error fetching latest terms and conditions:", error);
    showErrorToast("Failed to fetch terms and conditions");
    throw error;
  }
};

//Accept latets terms function

export const acceptLatestTerms = async (accessAuthToken: string): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/terms-and-conditions/accept`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to accept terms and conditions");
    }

    const data = await response.json();
    // console.log("acceptLatestTerms", data);

    return data;
  } catch (error) {
    console.error("Error accepting terms and conditions:", error);
    showErrorToast("Failed to accept terms and conditions");
    throw error;
  }
};
